import LightCard from "../../../../../../../../components/card/LightCard";
import RedHeader from "../../../../../../../../components/ui/RedBgTitleHeader";
import { useTranslation } from "react-i18next"
import React, {Fragment, useEffect, useState} from "react";
import AdditionalMusicianItem from "./AdditionalMusicianItem";
import PopupWithContext from "../../../../../../../../components/ui/Popup/PopupWithContext";
import AdditionalCostPopupForm from "./popupForm/AdditionalCostPopupForm";
import OkBtnPopupContext from "../../../../../../../../components/ui/Popup/OkBtnPopupContext";
import AddMusCostsMainTitles from "./AddMusCostsMainTitles";
import AddTotalCostsFooter from "./AddTotalCostsFooter";
import {projectCurrent} from "../../../../../../../../services/api/endpoints";
import useEndpoint from "../../../../../../../../hooks/useEndpiont";
import {calculateTotalCosts} from "./utility";


const popupInit = {show: false, title: '', variant: 'error', message: ''}

const flattenData = (objData) => ({
    other_costs: objData.flatMap(m =>
        m.categories.map(c => ({
            pmp_id: m.id,
            category_cost: c.categorie,
            description_cost: c.title,
            client_cost: c.client_cost,
            estro_cost: c.estro_cost
        }))
    )
});

export const AdditionalProjectCosts = ({additional_musicians, setAdditionalTotalSum}) => {
    const { t } = useTranslation()
    const [popup, setPopup] = useState(popupInit)
    const [peoples, setPeoples] = useState([])
    const [categorise_sum, setCategorise_sum] = useState({})
    const { makeRequest, loading, error, reset } = useEndpoint();

    useEffect(() => {
        const additional_musicians_copy = structuredClone(additional_musicians);
        setPeoples([...additional_musicians_copy]);
    }, [])

    const calculate_cost = calculateTotalCosts(peoples)

    const handlePopup = (type, musician, newValue) => {
        if (type === 'cancel') {
            setPopup(popupInit)
        }
        if (type === 'additionalForm') {
            setPopup({
                show: true,
                title: t("popups.formular_data.title"),
                variant: 'editF',
                message: t("popups.formular_data.description"),
                leftBtn: t("common.button.save"),
                rightBtn: t("common.button.cancel"),
                handlerPopup: "handleOkClick",
                formName: "additionalForm",
                formData: musician,
            })
        }

        if (type.type === 'ok') {
            setAdditionalTotalSum({
                client_cost: +calculate_cost.totalClientCost,
                estro_cost: +calculate_cost.totalEstroCost,
                grant_cost: 0.00,
                total: 0.00
            })
            setPopup(popupInit)
        }

        if (type === 'save') {
            const peoples_copy = structuredClone(peoples)
            const categorie_music = peoples_copy.find(el => el.musician_id === musician.musician_id)
            if (categorie_music) {
                categorie_music.categories.push(newValue)
                setPeoples(peoples_copy)
            }
            setPopup(popupInit)
        }
    }

    const popupForm = {
        additionalForm: <AdditionalCostPopupForm
            handlePopup={handlePopup}
            formData={popup.formData}
            saveBtn={t(popup.leftBtn)}
            cancelBtn={t(popup.rightBtn)}
        />,
        OkBtn: <OkBtnPopupContext okBtn={t(popup.okBtn)} handlePopup={handlePopup} />,
    }

    const changeHandler = (fieldName, val, musician_id, categ_entry_id) => {
        const musicianCopy = structuredClone(peoples);
        const musicianItem = musicianCopy.find(item => item.musician_id === musician_id);

        if (musicianItem.categories && musicianItem.categories.length > 0) {
            if (fieldName === 'remove') {
                musicianItem.categories = musicianItem.categories.filter(
                    item => item.id !== categ_entry_id
                );
                const newCategoriseSum = { ...categorise_sum };
                delete newCategoriseSum[categ_entry_id];
                setCategorise_sum(newCategoriseSum);
            } else {
                const musicianCategItem = musicianItem.categories.find(
                    item => item.id === categ_entry_id
                );
                if (musicianCategItem) {
                    musicianCategItem[fieldName] = val;
                    setCategorise_sum({
                        ...categorise_sum,
                        [musicianCategItem.id]: {
                            client_cost: Number(musicianCategItem.client_cost),
                            estro_cost: Number(musicianCategItem.estro_cost)
                        }
                    });
                }
            }
            setPeoples(musicianCopy);
        }
    }

    const saveHandler = async () => {
        const payload = flattenData(peoples)
        await makeRequest("api/project-current/summary-save-additional-musicians-costs", "POST", payload);
        setPopup({
            show: true,
            title: "Saved",
            message: 'Dane zostały zapisane',
            okBtn: t("common.button.ok"),
            formName: 'OkBtn',
            handlerPopup: "handleOkClick",
            variant: "success",
        })
    }

    return (<>
        {popup.show
            ?  <PopupWithContext
                    variant={popup.variant}
                    title={t(popup.title)}
                    message={t(popup.message)}
                >
                    {popupForm[popup.formName]}
                </PopupWithContext>
            : (<>
                <LightCard>
                    <RedHeader title={t('events.summary.addi_mus_costs_title')} />

                    <AddMusCostsMainTitles />

                    {
                        peoples.map((musician, index) => (<Fragment key={index}>
                                <AdditionalMusicianItem
                                    musician={musician}
                                    index={index+1}
                                    handlePopup={handlePopup}
                                    changeHandler={changeHandler}
                                />
                            </Fragment>)
                        )
                    }
                    <AddTotalCostsFooter data={calculate_cost} saveHandler={saveHandler}  />
                </LightCard>
              </>)
        }
    </>);
}